var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34px",
    height: "44px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "34px",
    height: "44px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAsCAMAAAA3k5qAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAQlBMVEX///////+m2sFpwpc8r3e04Mt4yKF3yKFowpbS7eCl2sDh8+pavIxZu4zw+fW14csPnVgtqW0do2Ieo2IsqWz///8WUySvAAAAEHRSTlMALofF8Xq1t8VciUzT1T54yKEnjwAAAAFiS0dEAIgFHUgAAAAHdElNRQfoAhQSKy4mfCdfAAAA2klEQVQ4y9WT6w6DIAyFOYoTRJHb+z/rLLhNVIjZkmU7v2z56GksZSwXFrGygKblxvC2KWHorFllu1MGN7PR7YRBbzL1OLrEAyEBKeLnwQvUh5MxDemonz0y0EW5ZiEpGnaIyOxBodj5cCryiqkMz51AlVGOv4bQdGNqo0ecADV6U5AfFUGqCERILUUmU9UEBl9HPFLvNf05Ejqtu1BDgl7+N3SoIOnVr9twjug0evUZcsHIpnZtBTF21nrOiJ+e0duIqxMBV5aEqWoZp+LCTkXITQrPtS9pOb4D+Bw+JMjt9GMAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.9ed61f2beb11999d7e86a9712587217d.svg";
export { ForwardRef as ReactComponent };